import useTranslation from '../../../localization/i18n.context';
import NavigationUtils from '../../../utils/navigation.utils';
import Alert from '../../shared/Alert/Alert';
import PaymentStatus from '../../../constants/payment.status';
import { EnterAmountType } from '../../../routes/EnterAmountPage/EnterAmountProvider';
import CardStatus from '../../../constants/card.status';

const PaymentStatusMessage = ({
  status,
  cardStatus = '',
  size = CreditPaymentMessage.Size.LARGE,
  amount = 0,
  availableDate = '',
  navigate,
  className = '',
}) => {
  const { t } = useTranslation();
  const messages = [];
  const routeNavigation =
    cardStatus === CardStatus.LOCKED
      ? NavigationUtils.Routes.CARD_SETTINGS
      : NavigationUtils.Routes.ENTER_AMOUNT;

  if (status === PaymentStatus.ON_TIME) {
    if (amount === 0) {
      messages.push(
        <Alert
          hasIcon
          className={className}
          size={size}
          type={Alert.Type.INFO}
          message={t('Payment will be available from {date}', {
            '{date}': availableDate,
          })}
        />,
      );
    } else {
      messages.push(
        <Alert
          hasIcon
          className={className}
          size={size}
          type={Alert.Type.INFO}
          message={t('New payment cycle available')}
          hasButton
          buttonText={t('Pay')}
          onButtonClick={() => {
            navigate(routeNavigation);
          }}
        />,
      );
    }
  }
  if (status === PaymentStatus.OVERDUE) {
    messages.push(
      <Alert
        hasIcon
        className={className}
        size={size}
        type={Alert.Type.ERROR}
        message={t('You have an overdue payment')}
        hasButton
        buttonText={t('Pay')}
        onButtonClick={() => {
          navigate(routeNavigation);
        }}
      />,
    );
  }

  return messages.length > 0 ? messages : <></>;
};

export default function CreditPaymentMessage({
  cardUid = '',
  cardStatus = '',
  status = '',
  amount = 0,
  organization = '',
  type = EnterAmountType.MICROLOAN_PAYMENT,
  size = CreditPaymentMessage.Size.LARGE,
  availableDate = '',
  className = '',
}) {
  const navigate = path => {
    const queryParams =
      cardStatus === CardStatus.LOCKED
        ? { organization: organization, source: NavigationUtils.Sources.WALLET }
        : {
            cardUidTo: cardUid,
            organizationCode: organization,
            type: type,
            source: NavigationUtils.Sources.WALLET,
          };

    NavigationUtils.navigate(path, false, queryParams);
  };
  return (
    <PaymentStatusMessage
      status={status}
      cardStatus={cardStatus}
      amount={amount}
      size={size}
      availableDate={availableDate}
      navigate={navigate}
      className={className}
    />
  );
}
CreditPaymentMessage.Size = Alert.Size;
